import Loadable from "react-loadable";
import { Entity } from "@radivision/graphql/lib/ts/graphql/entity";

import OptionsWithoutRender = LoadableExport.OptionsWithoutRender;

interface ComponentProps {
  entity: Entity;
  link: string;
  buttonText?: string;
}

type Props = ComponentProps;

const loadableOptions: OptionsWithoutRender<Props> = {
  loader: () => import("../../manage-pitch").then((module) => module.ConnectInvestorButton) as Promise<any>,
  loading: () => null,
};

export const ConnectInvestorButton = Loadable(loadableOptions);
